import ps, { ProviderSearchActionTypes } from './types/providerSearchActions';
import { ProviderSearch } from './types/providerSearch';

export const defaultProviderSearchState: ProviderSearch = {
  providers: [],
  selectedProviderID: '',
  actionInitiated: '',
  pageNo: 1,
  pageSize: 25,
  totalPages: 0,
  hasLoadedProviders: true,
  isLoadingProviderList: false,
  searchInput: '',
  sortBy: '',
  recommendation: '',
  entityType: '',
  hasError: false,
  isActionPending: false,
};

export default function providerSearchAdminReducer(
  state: ProviderSearch = defaultProviderSearchState,
  action: ProviderSearchActionTypes
) {
  switch (action.type) {
    case ps.FETCH_PROVIDER_DATA_PENDING: {
      return {
        ...state,
        isLoadingProviderList: true,
      };
    }
    case ps.FETCH_PROVIDER_DATA_FULFILLED: {
      const { data } = action.payload.data;
      const { pageSize, totalPages } = action.payload.data;
      return {
        ...state,
        providers: data,
        pageSize,
        totalPages,
        isLoadingProviderList: false,
      };
    }
    case ps.FETCH_PROVIDER_DATA_REJECTED: {
      return {
        ...state,
        providers: [],
        isLoadingProviderList: false,
      };
    }
    case ps.CREATE_PROVIDER_EXPERIENCE_PENDING: {
      return {
        ...state,
        hasError: false,
        isActionPending: true,
      };
    }
    case ps.CREATE_PROVIDER_EXPERIENCE_FULFILLED: {
      return {
        ...state,
        isActionPending: false,
      };
    }
    case ps.CREATE_PROVIDER_EXPERIENCE_REJECTED: {
      return {
        ...state,
        hasError: true,
        isActionPending: false,
      };
    }
    case ps.UPDATE_PROVIDER_EXPERIENCE_PENDING: {
      return {
        ...state,
        isActionPending: true,
        hasError: false,
      };
    }
    case ps.UPDATE_PROVIDER_EXPERIENCE_FULFILLED: {
      const updatedProvider = action.payload.data;
      const updatedProviders = state.providers.map(provider =>
        provider.npi === updatedProvider.npi ? updatedProvider : provider
      );
      return {
        ...state,
        providers: updatedProviders,
        isActionPending: false,
      };
    }
    case ps.UPDATE_PROVIDER_EXPERIENCE_REJECTED: {
      return {
        ...state,
        hasError: true,
        isActionPending: false,
      };
    }
    case ps.SET_SEARCH_INPUT: {
      const searchInput = action.payload;
      return {
        ...state,
        pageNo: 1,
        pageSize: 25,
        searchInput,
      };
    }
    case ps.SET_SORT_BY: {
      const sortBy = action.payload;
      return {
        ...state,
        pageNo: 1,
        pageSize: 25,
        sortBy,
      };
    }
    case ps.SET_RECOMMENDATION: {
      const recommendation = action.payload;
      return {
        ...state,
        pageNo: 1,
        pageSize: 25,
        recommendation,
      };
    }
    case ps.SET_ENTITY_TYPE: {
      const entityType = action.payload;
      return {
        ...state,
        pageNo: 1,
        pageSize: 25,
        entityType,
      };
    }
    case ps.SET_ACTION_INITIATED: {
      const actionInitiated = action.payload;
      return {
        ...state,
        actionInitiated,
      };
    }
    case ps.SET_SELECTED_PROVIDER_ID: {
      const selectedProviderID = action.payload;
      return {
        ...state,
        selectedProviderID,
      };
    }
    default: {
      return state;
    }
  }
}
